<div class="page-body">
  <div>
    <div style="margin-bottom:2em; padding:2em; border-bottom:1px solid #ccc; display:flex; flex-direction:row; justify-content: space-between; align-items: flex-start;">
      <div>
        <div>
          <img *ngIf="isEnglish()"  src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/eqao-logo-en/1601847625184/eqao-logo-en.png">
          <img *ngIf="!isEnglish()" src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/eqao-logo-fr/1601847673012/eqao-logo-fr.png">
        </div>
        <div *ngIf="isEnglish()">
          <i class="fas fa-home"></i>
          <span >/ Sample Test</span>
        </div>
      </div>
      <div *ngIf="!isEnglish()" style="display:flex; align-items: center; flex-direction: row;">
        <!-- <img style="width: 1.5em;" src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/France_flag%201/1601053949477/France_flag%201.png"> -->
        <a (click)="setLang('en')" style="margin-left:0.3em;">English</a>
      </div>
      <div *ngIf="isEnglish()" style="display:flex; align-items: center; flex-direction: row;">
        <img style="width: 1.5em;" src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/21/authoring/France_flag%201/1601053949477/France_flag%201.png">
        <a (click)="setLang('fr')" style="margin-left:0.3em;">Français</a>
      </div>
    </div>
    <div class="page-content" style="padding:2em; max-width:800px; margin:auto;">
      <h4> <tra-md slug="txt_g9_title"></tra-md></h4>
      <tra-md slug="txt_g9_cover"></tra-md>
      <div *ngIf="!isEnglish()" class="buttons" style="margin-top:2em; padding-bottom:6em; justify-content:center;">
        <a routerLink="/fr/test-auth/g9-sample/31/theorique" class="button is-large is-info"><tra slug="lbl_g9_vers_academic"></tra></a>
        <a routerLink="/fr/test-auth/g9-sample/30/applique" class="button is-large is-info"><tra slug="lbl_g9_vers_applied"></tra></a>
      </div>
      <div *ngIf="isEnglish()" class="buttons" style="margin-top:2em; padding-bottom:6em; justify-content:center;">
        <a routerLink="/en/test-auth/g9-sample/28/academic" class="button is-large is-info"><tra slug="lbl_g9_vers_academic"></tra></a>
        <a routerLink="/en/test-auth/g9-sample/29/applied" class="button is-large is-info"><tra slug="lbl_g9_vers_applied"></tra></a>
      </div>
    </div>
  </div>
</div>
  
